import Header from './components/Header';
import Hero from './components/Hero';
import MediaCards from './components/MediaCards';
import TopicIndex from './components/TopicIndex';
import InfoCards from './components/InfoCards';
import FaqSection from './components/FaqSection';
import TopicTags from './components/TopicTags';
import CommentsSection from './components/CommentsSection';
import UpdatesTimeline from './components/UpdatesTimeline';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';
import { featureItems } from '@/mocks/homeData';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <section id="app" className="py-10 md:py-14 bg-gradient-to-r from-primary-500 to-primary-600">
          <div className="section-container">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-white text-center md:text-left">
                <h2 className="font-heading text-xl md:text-2xl font-bold">随时随地，掌上吃瓜</h2>
                <p className="text-white/80 text-sm md:text-base mt-2 max-w-md">
                  打开手机浏览器访问 51吃瓜每日大赛，无需下载即可畅享全网最热吃瓜快讯。移动端已全面适配，流畅体验一触即达。
                </p>
              </div>
              <div className="flex items-center gap-3 md:gap-4">
                <div className="bg-white/20 backdrop-blur rounded-xl px-4 py-3 text-white text-center min-w-[80px]">
                  <div className="text-2xl font-bold">500万+</div>
                  <div className="text-xs text-white/70 mt-0.5">月活用户</div>
                </div>
                <div className="bg-white/20 backdrop-blur rounded-xl px-4 py-3 text-white text-center min-w-[80px]">
                  <div className="text-2xl font-bold">4.9</div>
                  <div className="text-xs text-white/70 mt-0.5">用户评分</div>
                </div>
                <div className="bg-white/20 backdrop-blur rounded-xl px-4 py-3 text-white text-center min-w-[80px]">
                  <div className="text-2xl font-bold">99.9%</div>
                  <div className="text-xs text-white/70 mt-0.5">服务可用率</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <MediaCards />

        <section id="about" className="py-12 md:py-16 bg-white">
          <div className="section-container">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="section-title">关于我们</h2>
                <p className="section-subtitle">了解51吃瓜每日大赛背后的故事</p>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
                <div>
                  <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                    51吃瓜每日大赛诞生于全民吃瓜时代，我们是一群热爱追踪热点、整理资讯的"专业吃瓜人"。从最初几个人手动刷新各大平台热搜，到如今覆盖50+主流平台的自动化聚合系统，我们始终坚持一个信念：<strong className="text-primary-500">让每一个吃瓜群众都能第一时间吃到最新鲜、最完整的瓜。</strong>
                  </p>
                  <p className="text-foreground-600 leading-relaxed text-sm md:text-base mt-4">
                    我们的编辑团队由资深媒体人、社交媒体分析师和内容策划专家组成，24小时轮班值守，确保任何时间爆出的热点事件都能在5分钟内上线快讯。我们不只是搬运热搜，更致力于还原事件全貌，提供多角度分析，让你吃瓜吃得明明白白。
                  </p>
                  <p className="text-foreground-600 leading-relaxed text-sm md:text-base mt-4">
                    目前，51吃瓜每日大赛日均更新超过200条内容，月活跃用户突破500万。我们将继续优化内容质量和更新速度，努力成为全网最值得信赖的吃瓜资讯平台。
                  </p>
                </div>
                <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20modern%20digital%20newsroom%20workspace%20with%20multiple%20glowing%20monitors%20displaying%20dashboard%20charts%20and%20social%20media%20feeds%2C%20warm%20coral%20and%20amber%20ambient%20lighting%2C%20team%20collaboration%20concept%2C%20editorial%20office%20aesthetic%2C%20clean%20modern%20design&width=800&height=600&seq=about-main&orientation=landscape"
                    alt="51吃瓜每日大赛编团队工作场景"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex gap-3">
                      <div className="bg-white/90 backdrop-blur rounded-lg px-3 py-2 text-center flex-1">
                        <div className="text-primary-500 font-bold text-lg">200+</div>
                        <div className="text-foreground-600 text-xs">日均更新</div>
                      </div>
                      <div className="bg-white/90 backdrop-blur rounded-lg px-3 py-2 text-center flex-1">
                        <div className="text-accent-500 font-bold text-lg">50+</div>
                        <div className="text-foreground-600 text-xs">覆盖平台</div>
                      </div>
                      <div className="bg-white/90 backdrop-blur rounded-lg px-3 py-2 text-center flex-1">
                        <div className="text-primary-500 font-bold text-lg">500万+</div>
                        <div className="text-foreground-600 text-xs">月活用户</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <TopicIndex />

        <InfoCards />

        <FaqSection />

        <TopicTags />

        <CommentsSection />

        <section id="features" className="py-12 md:py-16 bg-white">
          <div className="section-container">
            <div className="text-center mb-8 md:mb-12">
              <h2 className="section-title">平台特色</h2>
              <p className="section-subtitle">四大核心优势，打造最好的吃瓜体验</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {featureItems.map((item) => (
                <div
                  key={item.id}
                  className="bg-background-50 rounded-xl border border-background-200 p-5 md:p-6 hover:border-primary-200 transition-all group cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                    <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <UpdatesTimeline />

        <RankingSection />

        <section id="contact" className="py-12 md:py-16 bg-white">
          <div className="section-container">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="section-title">投稿爆料</h2>
              <p className="section-subtitle">有猛料？欢迎向我们投稿，一起吃遍天下大瓜</p>

              <div className="mt-8 md:mt-10 bg-background-50 rounded-2xl border border-background-200 p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                  <div className="text-center p-4">
                    <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-mail-send-line text-primary-500 text-xl"></i>
                    </div>
                    <h3 className="font-bold text-foreground-900 text-sm">爆料邮箱</h3>
                    <p className="text-xs text-foreground-500 mt-1">tips@51chigua.com</p>
                  </div>
                  <div className="text-center p-4">
                    <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-wechat-line text-accent-500 text-xl"></i>
                    </div>
                    <h3 className="font-bold text-foreground-900 text-sm">微信客服</h3>
                    <p className="text-xs text-foreground-500 mt-1">51chigua2026</p>
                  </div>
                  <div className="text-center p-4">
                    <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-briefcase-line text-secondary-500 text-xl"></i>
                    </div>
                    <h3 className="font-bold text-foreground-900 text-sm">商务合作</h3>
                    <p className="text-xs text-foreground-500 mt-1">biz@51chigua.com</p>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-background-200">
                  <p className="text-sm text-foreground-500">
                    爆料内容一经采用将注明来源并给予相应奖励。我们承诺严格保护爆料人隐私，绝不泄露个人信息。
                  </p>
                </div>
              </div>

              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  立即投稿
                </a>
                <a
                  href="#faq"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 bg-background-100 hover:bg-background-200 text-foreground-700 font-semibold text-sm px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer border border-background-300"
                >
                  <i className="ri-question-line"></i>
                  查看FAQ
                </a>
              </div>
            </div>
          </div>
        </section>

        <CarouselSection />
      </main>

      <Footer />
    </div>
  );
}